import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { buildTechnologyColumns } from './columns';
import { getTechnologyFields } from './fields';
import { getTechnologySimpleFilters } from './simpleFilters';

/**
 * Technology QueryEntity - bundles columns and fields
 */
export const technologyEntity: QueryEntity<unknown> = {
  primaryLabel: { actual: 'Technology' },
  buildColumns:
    buildTechnologyColumns as () => import('@/components/table/types').Columns<unknown>,
  getFields: getTechnologyFields,
  getSimpleFilters: getTechnologySimpleFilters,
};
